// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3Kw4d","consentsList":"PatientConsents_consentsList__17xaY","consentsListEmpty":"PatientConsents_consentsListEmpty__2of6U"};